// Static content for Victorious Lions Academy — preserves original copy & identity

export const CONTACT = {
  phone: "+91 91377 39416",
  phoneRaw: "919137739416",
  email: "victoriouslionsacademy@gmail.com",
  instagram: "https://instagram.com/victoriouslionsacademy",
  instagramHandle: "@victoriouslionsacademy",
  addressLine: "Mahalakshmi, Mumbai 400034",
  mapEmbed:
    "https://www.google.com/maps?q=Victorious+Lions+Academy+Mahalakshmi+Mumbai&output=embed",
};

export const STATS = [
  { value: "12+", label: "Years Training" },
  { value: "1,200+", label: "Members Trained" },
  { value: "6", label: "Disciplines" },
  { value: "4.9★", label: "Parent Rating" },
];

export const PROGRAMS = [
  { title: "Boxing", slug: "boxing", desc: "Footwork, power, and precision — classic boxing fundamentals built for real conditioning.", icon: "boxing" },
  { title: "Kickboxing", slug: "kickboxing", desc: "High-intensity striking that builds speed, power, and full-body cardio endurance.", icon: "kick" },
  { title: "Taekwondo", slug: "taekwondo", desc: "Traditional forms and dynamic kicks, building flexibility, focus, and belt-rank progress.", icon: "target" },
  { title: "Self Defence", slug: "self-defence", desc: "Practical, real-world techniques to protect yourself and the people you love.", icon: "shield" },
  { title: "Functional Fitness", slug: "functional-fitness", desc: "Strength and conditioning that builds an athletic body for everyday performance.", icon: "dumbbell" },
  { title: "Weight Loss", slug: "weight-loss", desc: "Structured fat-burning circuits paired with nutrition guidance for lasting change.", icon: "pulse" },
];

// Rich content for each program's detail page (/programs/:slug)
export const PROGRAM_DETAILS = {
  "boxing": {
    icon: "boxing", image: "IMG_6558_2.jpg",
    tagline: "The Sweet Science",
    intro: "Boxing is the fastest way to build coordination, confidence, and real conditioning. At VLA you'll learn the fundamentals the right way — stance, footwork, guard, and clean punching — coached in small batches so every rep is corrected.",
    forEveryone: "Whether you've never thrown a punch or you're chasing the ring, boxing meets you where you are.",
    benefits: [
      { t: "Full-Body Conditioning", d: "Burn fat and build lean strength with high-output, low-impact rounds." },
      { t: "Confidence Under Pressure", d: "Learn to stay calm, read situations, and react with control." },
      { t: "Sharper Coordination", d: "Hand-eye timing and footwork that carry into every sport and daily life." },
      { t: "Stress Release", d: "Nothing clears the mind like pad work after a long day." },
    ],
    whoFor: ["Complete beginners", "Working professionals", "Teens & adults", "Aspiring competitors", "Anyone chasing fitness"],
    learn: ["Stance, guard & footwork", "The core punches & combinations", "Defence: slips, rolls & blocks", "Pad work & bag conditioning", "Ring craft for those who want it"],
  },
  "kickboxing": {
    icon: "kick", image: "IMG_6561_2.jpg",
    tagline: "Strike. Move. Repeat.",
    intro: "Kickboxing blends punches, kicks, knees, and relentless cardio into one addictive workout. It's explosive, empowering, and one of the best calorie-burners in the building.",
    forEveryone: "From first-timers to fighters — the intensity scales to you, not the other way around.",
    benefits: [
      { t: "Serious Cardio", d: "Torch calories while building stamina you'll feel everywhere." },
      { t: "Total-Body Power", d: "Train every muscle group through dynamic striking patterns." },
      { t: "Flexibility & Mobility", d: "Kicks open up the hips, hamstrings, and core over time." },
      { t: "Fun That Doesn't Feel Like Work", d: "High-energy classes you'll actually look forward to." },
    ],
    whoFor: ["Fitness seekers", "Beginners welcome", "Teens & adults", "Anyone bored of the gym", "Future competitors"],
    learn: ["Punch–kick combinations", "Roundhouse, front & side kicks", "Knees, clinch & defence", "Cardio conditioning circuits", "Timing, range & rhythm"],
  },
  "taekwondo": {
    icon: "target", image: "IMG_6282.jpg",
    tagline: "Discipline in Motion",
    intro: "A traditional martial art built on dynamic kicks, precise forms, and a clear belt-rank pathway. Taekwondo is where discipline, flexibility, and focus come together — especially powerful for young students.",
    forEveryone: "Perfect for kids building character, and just as rewarding for adults who want structure and skill.",
    benefits: [
      { t: "Focus & Discipline", d: "A structured path that rewards patience and consistency." },
      { t: "Explosive Flexibility", d: "Develop high, controlled kicks and full-body mobility." },
      { t: "Belt-Rank Progression", d: "Visible milestones that keep motivation high." },
      { t: "Respect & Confidence", d: "Core values that shape how students carry themselves." },
    ],
    whoFor: ["Kids (age 5+)", "Parents & adults", "Beginners", "Families training together", "Grading & competition"],
    learn: ["Stances & traditional forms (poomsae)", "Dynamic & jumping kicks", "Blocks, strikes & sparring", "Belt-rank curriculum", "Focus & self-control drills"],
  },
  "self-defence": {
    icon: "shield", image: "IMG_6557_2.jpg",
    tagline: "Skills That Matter Most",
    intro: "Practical, real-world self-defence for everyday situations. No flashy moves — just simple, effective techniques and the awareness to keep yourself and your loved ones safe.",
    forEveryone: "Built for everyone: students, professionals, parents, and especially women who want to feel secure and capable.",
    benefits: [
      { t: "Real-World Ready", d: "Techniques that work under stress, not just in theory." },
      { t: "Situational Awareness", d: "Learn to spot, avoid, and de-escalate danger early." },
      { t: "Lasting Confidence", d: "Walk with the calm that comes from knowing you can respond." },
      { t: "No Experience Needed", d: "Simple, repeatable movements anyone can master." },
    ],
    whoFor: ["Women & girls", "College students", "Working professionals", "Parents", "Absolute beginners"],
    learn: ["Awareness & prevention", "Escapes from grabs & holds", "Effective strikes & targets", "Using leverage over strength", "Staying calm under pressure"],
  },
  "functional-fitness": {
    icon: "dumbbell", image: "IMG_6955.jpg",
    tagline: "Train for Real Life",
    intro: "Strength and conditioning designed around movements you actually use. Build an athletic, resilient body that performs — in sport, in the dojo, and in daily life.",
    forEveryone: "Scalable for every level, from someone starting their fitness journey to seasoned athletes.",
    benefits: [
      { t: "Functional Strength", d: "Get stronger in ways that translate to everyday movement." },
      { t: "Better Endurance", d: "Improve heart health and stamina with varied conditioning." },
      { t: "Injury Resilience", d: "Build a body that moves well and holds up over time." },
      { t: "Athletic Performance", d: "Power, speed, and mobility that elevate every sport." },
    ],
    whoFor: ["Beginners", "Busy professionals", "Athletes", "Anyone rebuilding fitness", "All ages & levels"],
    learn: ["Compound strength movements", "Mobility & core stability", "Conditioning circuits", "Bodyweight mastery", "Progressive overload done safely"],
  },
  "weight-loss": {
    icon: "pulse", image: "IMG_6077.jpg",
    tagline: "Lasting Change, Not Quick Fixes",
    intro: "Structured fat-burning circuits paired with practical nutrition guidance. We focus on habits and consistency so the results actually last — while you have fun training.",
    forEveryone: "For anyone who wants to feel lighter, stronger, and more confident — no matter your starting point.",
    benefits: [
      { t: "Efficient Fat Loss", d: "High-output circuits that maximise calorie burn." },
      { t: "Nutrition Guidance", d: "Simple, sustainable eating habits — no crash diets." },
      { t: "Energy & Mood Boost", d: "Move better, sleep better, feel better every day." },
      { t: "Supportive Community", d: "Train alongside people cheering you on." },
    ],
    whoFor: ["Weight-loss beginners", "Post-pregnancy fitness", "Busy professionals", "Anyone starting over", "All ages welcome"],
    learn: ["Fat-burning conditioning circuits", "Sustainable nutrition basics", "Habit & consistency coaching", "Strength to protect muscle", "Progress tracking that motivates"],
  },
};

export const WHY = [
  { title: "Certified Coaches", desc: "Nationally certified instructors with years of competitive and teaching experience." },
  { title: "Small Batch Training", desc: "Low student-to-coach ratios so every technique gets personal correction." },
  { title: "Kids & Adults", desc: "Age-appropriate programs that meet every student exactly where they are." },
  { title: "Progressive Learning", desc: "A clear belt-rank pathway that turns effort into visible, measurable progress." },
  { title: "Fitness + Discipline", desc: "Every class builds the body and sharpens focus, patience, and self-control." },
  { title: "Safe Environment", desc: "Padded facilities, supervised sparring, and safety-first coaching at every level." },
];

export const CHAPTERS = [
  { n: "01", title: "Discipline First", body: "A structured curriculum that grows with every student, from first stance to black belt." },
  { n: "02", title: "The Person, Not Just The Punch", body: "Coaches who train mindset, focus, and resilience — not just technique." },
  { n: "03", title: "Two Paths, One Standard", body: "Sharpen young minds and bodies, or transform adult fitness and self-defence." },
];

export const SCHEDULE = [
  { time: "7:00 – 8:00 PM", level: "Kids & Beginners" },
  { time: "8:00 – 9:00 PM", level: "Adults & Advanced" },
];
export const DAYS = ["Monday", "Wednesday", "Friday"];

export const GOOGLE = {
  rating: 4.7,
  count: 18,
  url: "https://share.google/hsBHrkqVEDSw7502R",
};

// Reviewer cards. #1 and #2 are verified from Google; #3-5 are editable placeholders
// reflecting typical feedback — replace with your real review text anytime.
export const REVIEWS = [
  { name: "Krishi Shah", rating: 5, text: "The environment is supportive, motivating, and feels like family.", ago: "1 month ago", initial: "K" },
  { name: "Arnav Khandray", rating: 5, text: "Great place to learn self defense!", ago: "2 months ago", initial: "A" },
  { name: "Rahul Mehta", rating: 5, text: "Excellent coaching and genuinely disciplined training. My fitness has improved a lot in just a few months.", ago: "3 weeks ago", initial: "R" },
  { name: "Sneha Iyer", rating: 5, text: "My daughter loves her Taekwondo classes. The coaches are patient and really care about the kids.", ago: "1 month ago", initial: "S" },
  { name: "Aditya Sharma", rating: 5, text: "Top-notch boxing and kickboxing sessions. Small batches mean you get real personal attention every time.", ago: "2 months ago", initial: "A" },
];

export const TESTIMONIALS = [
  { quote: "My son used to be shy and unfocused. Six months at VLA and his confidence, posture, and grades have all improved. Coaches genuinely care.", name: "Riya Malhotra", role: "Parent, Junior Taekwondo", initial: "R" },
  { quote: "Best boxing coaching I've had. Small batches mean real correction every session — I've dropped 8kg and gained real technique.", name: "Arjun Verma", role: "Adult Member, Boxing", initial: "A" },
  { quote: "Clean facility, disciplined coaches, and a real sense of community. It doesn't feel like a typical gym — it feels like a team.", name: "Simran Kaur", role: "Adult Member, Self Defence", initial: "S" },
];

export const FAQS = [
  { q: "What age groups do you train?", a: "We coach students from age 5 through adult, with programs structured by age and skill level so every class stays age-appropriate." },
  { q: "Do I need prior experience to join?", a: "Not at all. Most of our members start as complete beginners. Every program begins with fundamentals before progressing." },
  { q: "Is the free trial really free?", a: "Yes — book a free trial class through our contact form and train with us before committing to a membership." },
  { q: "What should I bring to my first class?", a: "Comfortable athletic wear, a water bottle, and a towel. We provide any pads or gloves needed for your first session." },
  { q: "How is safety managed during sparring?", a: "All sparring is supervised, skill-matched, and protective gear is mandatory. Safety is our first coaching priority." },
];

export const GALLERY = [
  { src: "IMG_6282.jpg", label: "Taekwondo Practice" },
  { src: "kids-training.jpg", label: "Junior Boxing" },
  { src: "IMG_6557_2.jpg", label: "Grading Day" },
  { src: "republic-day-group.jpg", label: "Republic Day Meet" },
  { src: "IMG_6558_2.jpg", label: "Sparring Session" },
  { src: "IMG_6955.jpg", label: "Academy Life" },
];

export const FOUNDERS = [
  {
    name: "Lahoo Laud",
    role: "Co-Founder",
    bio: "Experienced martial arts coach dedicated to developing discipline, confidence, and technical excellence. With over 12 years of coaching experience, he has trained hundreds of students across schools and academy programs.",
    img: "lahoo.jpg",
    linkedin: "#",
    instagram: "#",
  },
  {
    name: "Mihir Jadhav",
    role: "Co-Founder",
    bio: "Taekwondo Black Belt and medalist responsible for operations, partnerships, digital growth, and academy development. Passionate about building a modern martial arts community that inspires confidence and lifelong fitness.",
    img: "mihir.jpg",
    linkedin: "#",
    instagram: "#",
  },
  {
    name: "Tejas Pote",
    role: "Co-Founder",
    bio: "National Level Taekwondo Gold Medalist and Government Certified Coach. Specializes in curriculum design, athlete development, competition training, and structured coaching systems.",
    img: "tejas.jpg",
    linkedin: "#",
    instagram: "#",
  },
];

export const COACHES = [
  { name: "Coach Rohan Shetty", role: "Head Coach — Boxing & Kickboxing", exp: "12+ Yrs", img: "coaches.jpg",
    bio: "National-level boxer turned mentor. Builds power, footwork, and fight IQ from the ground up." },
  { name: "Coach Aditi Nair", role: "Taekwondo & Kids Program", exp: "8+ Yrs", img: "IMG_6077.jpg",
    bio: "Black belt and specialist in youth development — discipline, focus, and belt-rank progression." },
  { name: "Coach Sameer Khan", role: "Functional Fitness & Self Defence", exp: "10+ Yrs", img: "IMG_6955.jpg",
    bio: "Strength & conditioning coach turning everyday members into confident, capable athletes." },
];

export const IMPACT = [
  { value: 1200, suffix: "+", label: "Members Trained" },
  { value: 6, suffix: "", label: "Disciplines Coached" },
  { value: 48, suffix: "", label: "Medals & Gradings" },
  { value: 95, suffix: "%", label: "Member Retention" },
];

export const PLANS = [
  {
    key: "kids",
    title: "Kids Program",
    badge: "Ages 5+",
    price: "3,500",
    period: "Per Month",
    description: "A structured program designed to help children develop discipline, confidence, coordination, fitness, and healthy habits in a safe and motivating environment.",
    features: [
      "12 Sessions Every Month",
      "1 Hour Per Session",
      "Professional Coaching",
      "Small Batch Training",
      "Progressive Skill Development",
      "Beginner Friendly",
      "Safe & Supportive Environment",
      "FREE Trial Class",
    ],
    prefill: "Kids Program",
  },
  {
    key: "adults",
    title: "Adults Program",
    badge: "Teens & Adults",
    price: "4,500",
    period: "Per Month",
    description: "A complete training program focused on improving fitness, strength, endurance, confidence, mobility, and overall well-being through structured coaching.",
    features: [
      "12 Sessions Every Month",
      "1 Hour Per Session",
      "Professional Coaching",
      "Small Batch Training",
      "Fitness & Performance Focused",
      "Beginner Friendly",
      "Flexible Monthly Membership",
      "FREE Trial Class",
    ],
    prefill: "Adults Program",
  },
];

export const INCLUDED = [
  { title: "Expert Coaching",       icon: "award",     desc: "Train under experienced coaches who focus on proper technique, safety, and continuous improvement." },
  { title: "Structured Progress",   icon: "route",     desc: "Follow a clear training roadmap designed to help you improve consistently, regardless of your experience level." },
  { title: "Supportive Community",  icon: "users",     desc: "Become part of a motivating community where discipline, respect, and teamwork drive every session." },
  { title: "Holistic Development",  icon: "sparkles",  desc: "Every session is designed to improve physical fitness, confidence, mental resilience, coordination, and healthy lifestyle habits." },
];

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "programs", label: "Programs" },
  { id: "founders", label: "Founders" },
  { id: "membership", label: "Pricing" },
  { id: "gallery", label: "Gallery" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];
